<template>
  <div>
    <NavBar class="bg-yellow"></NavBar>

    <transition enter-active-class="animated fadeIn faster">
      <router-view></router-view>
    </transition>
    <!--      <CookieManager></CookieManager>-->
    <Footer class="bg-yellow"></Footer>
    <CopyRight class="bg-yellow"></CopyRight>
    <!--    <v-tour name="EasyRemessaTour" :steps="steps" :callbacks="vueTourCallbacks"></v-tour>-->
  </div>
</template>

<script>
// @ is an alias to /src
import Cookies from "js-cookie";

// Modals
import NavBar from "@/components/NavBar.vue";
import Footer from "@/components/Footer.vue";
import CopyRight from "@/components/CopyRight.vue";
// import CookieManager from "@/components/CookieManager.vue";

export default {
  name: "home",
  components: {
    NavBar,
    Footer,
    CopyRight,
    // CookieManager
  },
  data() {
    return {
      logged_in: false,
      steps: [
        {
          target: "#v-step-1", // We're using document.querySelector() under the hood
          header: {
            title: "Get Started"
          },
          content: `<p class="text-left">Would you like a <strong>guided tour</strong> of EasyRemessa? <br> Click 'Next' To Proceed !!</p>`
        },
        {
          target: "#v-step-2", // We're using document.querySelector() under the hood
          header: {
            title: "Send Money"
          },
          content: "Choose amount and delivery currency",
          offset: -300
        },
        {
          target: "#v-step-3", // We're using document.querySelector() under the hood
          header: {
            title: "Transfer Money"
          },
          content: "Click here to transfer amount",
          offset: -300
        }
      ],
      vueTourCallbacks: {
        onSkip: this.skipTour
      }
    };
  },
  created() {

  },
  computed: {
    is_doing_transfer() {
      return this.$store.getters.GetDoingPersonalTransferStatus;
    },
  },
  mounted: function () {
    // const skipTour = Cookies.get("skip-tour");
    // if (!skipTour) {
    //   this.$tours["EasyRemessaTour"].start();
    // }
  },
  methods: {
    skipTour() {
      Cookies.set("skip-tour", true, {expires: 120, sameSite: 'strict'});
      console.log("Tour skipped");
    }
  }
};
</script>

<style lang="scss">
.home {
  overflow: hidden;
}

:focus {
  box-shadow: none !important;
  outline: none !important;
}

$blue: blue;
</style>
